<template lang="pug">
  v-container#patient-profile(fluid='' tag='section')
    v-dialog(v-model='dialog' scrollable='' max-width='400px')
      v-card
        v-card-title Selecciona una Imagen
        v-divider
        v-card-text(style='text-align: center;')
          img(:src='imageUrl' height='150' v-if='imageUrl' alt='Imagen para seleccionar')
          v-text-field(label='Seleccionar' @click='pickFile' v-model='imageName' prepend-icon='mdi-upload')
          input(type='file' style='display: none' ref='image' accept='image/*' @change='onFilePicked')
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='red' text='' @click='dialog=false') CANCELAR
          v-btn(color='blue darken-1' @click='upload') ACEPTAR
    v-snackbar(v-model='snackbar.show' :timeout='30000' :color='snackbar.color' top='' right='' :multi-line='multiLine')
      | {{ snackbar.text }}
      template(v-slot:action='{ attrs }')
        v-btn(dark='' text='' icon='' @click='snackbar.show = false' v-bind='attrs')
          v-icon mdi-close
    //- v-snackbar(v-model='snackbar.show' :timeout='30000' top='' right='' :color='snackbar.color')
    //-   | {{ snackbar.text }}
    //-   v-btn(dark='' text='' @click.native='snackbar.show = false' icon='')
    //-     v-icon mdi-close
    v-card(v-if="!userStatus && !selectedPatient")
      v-toolbar(text='' color='primary' dark='')
        v-toolbar-title {{patient.names != '' ? patient.names + ' ' + patient.lastNames : 'Nuevo Paciente'}}
          v-btn(icon="" dark="" @click="exitPatientDialog()" style="position: absolute; top: 0px; right: 10px;")
            v-icon.primary.rounded mdi-close
      v-card-text
        div(style="widht: 100% text-align: center; padding-top: 100px;")
          v-alert(type='error')
            | Ha llegado al límite de pacientes dentro de su plan o su cuenta se encuentra inactiva. Debe ponerse en contacto con su proovedor para verificar este error, de lo contrario por favor active su plan para seguir ingresando nuevos pacientes, gracias.
        row
          v-col(cols='12' md="12").text-center
            v-btn.ml-2(min-width='0' text='' style='' @click="openLink('https://www.facebook.com/dental.prime.391/')")
              v-icon(color="black") mdi-facebook
            v-btn.ml-2(min-width='0' text=''  style="" @click="openLink('https://www.instagram.com/dentalprimeapp/')")
              v-icon(color="black") mdi-instagram
            v-btn.ml-2(min-width='0' text='' style="" @click="openLink('https://wa.me/+593984530998')")
              v-icon(color="black") mdi-whatsapp
    v-card(v-if="userStatus || selectedPatient")
      v-toolbar(text='' color='primary' dark='')
        v-toolbar-title {{patient.names != '' ? patient.names + ' ' + patient.lastNames : 'Nuevo Paciente'}}
          v-btn(icon="" dark="" @click="exitPatientDialog" style="position: absolute; top: 0px; right: 10px;")
            v-icon.primary.rounded mdi-close
      v-tabs
        v-tab(@click="selectTab = true")
          |         Datos
        v-tab(v-if="selectedPatient && seeData" @click="selectTab = false")
          |         Anamnesis
        v-tab(v-if="selectedPatient && seeData" @click="selectTab = false")
          |         Signos Vitales
        v-tab(v-if="selectedPatient && seeData" @click="selectTab = false")
          |         Examen Físico
        v-tab(v-if="selectedPatient && seeData" @click="selectTab = false")
          |         Preguntas Frecuentes
        v-tab(v-if="selectedPatient && seeData && seeAppointment" @click="selectTab = false")
          |         Citas
        v-tab-item
          v-tabs(vertical='' v-model='tabData')
            v-tooltip(right='' color='cyan darken-1')
              template(v-slot:activator='{ on, tooltip }')
                v-tab(ripple href='#tab-1-1' v-bind='tooltip' v-on='on')
                  v-icon(left='' style="position: absolute; left: 15px;") mdi-account
              span Personales
            v-tooltip(right='' color='cyan darken-1')
              template(v-slot:activator='{ on, tooltip }')
                v-tab(ripple href='#tab-1-2' v-bind='tooltip' v-on='on')
                  v-icon(left='' style="position: absolute; left: 15px;") mdi-calendar
              span Nacimiento
            v-tooltip(right='' color='cyan darken-1')
              template(v-slot:activator='{ on, tooltip }')
                v-tab(ripple href='#tab-1-3' v-bind='tooltip' v-on='on')
                  v-icon(left='' style="position: absolute; left: 15px;") mdi-home
              span Residencia
            v-tooltip(right='' color='cyan darken-1')
              template(v-slot:activator='{ on, tooltip }')
                v-tab(ripple href='#tab-1-4' v-bind='tooltip' v-on='on')
                  v-icon(left='' style="position: absolute; left: 15px;") mdi-code-greater-than
              span Adicional
            v-tooltip(right='' color='cyan darken-1')
              template(v-slot:activator='{ on, tooltip }')
                v-tab(ripple href='#tab-1-5' v-bind='tooltip' v-on='on')
                  v-icon(left='' style="position: absolute; left: 15px;") mdi-contacts
              span Contacto
            v-tab-item(value='tab-1-1')
              v-card(flat='' style="padding: 0px;")
                v-card-text(style="padding: 0px;")
                  h3(style="text-align: center; color: primary;") DATOS PERSONALES
                  v-row(justify='center')
                    v-col(cols='12' md='12' style="padding: 0px;")
                      v-form(ref='formPatient')
                        v-container.py-0
                          v-row
                            v-col(cols='12' md='3' style="text-align: center;")
                              v-row
                                v-col(cols='12')
                                  img(style="width: 205; max-width: 200px !important; height: 220px !important;" :src='patient.imagePatientUrl' alt='Imagen de paciente')
                              v-row
                                v-col(cols='12')
                                  v-btn.mr-0(color='primary' rounded='' @click='dialog = true')
                                    | Actualizar Imagen
                            v-col(cols='12' md='9')
                              v-row
                                v-col(cols='12' md='2')
                                  v-text-field.purple-input(v-model='patient.hcNumber' label='Número H.C.')
                                v-col(cols='12' md='5')
                                  v-text-field.purple-input(v-model='patient.names' label='Nombre' :rules='requeridos')
                                v-col(cols='12' md='5')
                                  v-text-field.purple-input(v-model='patient.lastNames' label='Apellido' :rules='requeridos')
                                //- <!--v-col(cols='12' md='6')-->
                                //- <!--v-combobox.purple-input(v-model='patient.tipoId' label='Tipo de identificación' :items='tipoId' :rules='requeridos')-->
                                v-col(cols='12' md='3')
                                  v-select.purple-input(v-model='patient.tipoId' :items="['Cédula', 'Pasaporte']" label='Tipo de identificación')
                                v-col(cols='12' md='3' v-if="patient.tipoId === 'Cédula'")
                                  v-text-field.purple-input(v-model='patient.id' label='Número de Cédula')
                                v-col(cols='12' md='3' v-if="patient.tipoId === 'Pasaporte'")
                                  v-text-field.purple-input(v-model='patient.id' label='Número de Pasaporte')
                                v-col(cols='12' md='6')
                                  v-text-field.purple-input(:rules='emailRules' v-model='patient.email' label='Correo Electrónico')
                                v-col(cols='12' md='3')
                                  v-select.purple-input(v-model='patient.sex' label='Sexo' :items='items')
                                v-col(cols='12' md='3')
                                  v-select.purple-input(v-model='patient.estadoCivil' label='Estado Civil' :items='estadoCivilLst')
                                v-col(cols='12' md='6')
                                  v-text-field.purple-input(v-model='patient.phone2' label='Celular' type='number')
                                v-col(cols='12' md='3')
                                  v-text-field.purple-input(v-model='patient.phone1' label='Teléfono Principal' type='number')
                                v-col(cols='12' md='3')
                                  v-text-field.purple-input(v-model='patient.phone3' label='Teléfono 3' type='number')
                                v-col(cols='12' md='2' style="text-align: center;")
                                  v-switch.purple-input(v-if='patient.active === true' v-model='patient.active' label='Paciente Activo')
                                  v-switch.purple-input(v-if='patient.active === false' v-model='patient.active' label='Paciente Innactivo')
                            v-col(cols='12' md='6')
                              v-menu(ref='menu' v-model='menu' :close-on-content-click='false' :return-value.sync='date' transition='scale-transition' offset-y='' min-width='290px')
                                template(v-slot:activator='{ on }')
                                  v-text-field(v-model='patient.bornDate' label='Fecha de Nacimiento' prepend-icon='mdi-calendar' readonly='' v-on='on')
                                v-date-picker(@change="$refs.menu.save(date), calc_edad()" v-model='patient.bornDate' no-title='' scrollable='' style='margin:0px;')
                                  v-spacer
                            v-col(cols='4' md="2")
                              v-text-field.purple-input(v-model='patient.years' label='Años' readonly disabled)
                            v-col(cols='4' md="2")
                              v-text-field.purple-input(v-model='patient.months' label='Meses' readonly disabled)
                            v-col(cols='4' md="2")
                              v-text-field.purple-input(v-model='patient.days' label='Días' readonly disabled)
            v-tab-item(value='tab-1-2')
              v-card(flat='')
                v-card-text
                  h3(style="text-align: center; color: primary;") DATOS DE NACIMIENTO
                  v-row(justify='center')
                    v-col(cols='12' md='12')
                      v-container.py-0
                        v-row
                          v-col(cols='12' md='4')
                            v-select(v-model='paisVal' :items='paisLst' item-text='id' label='Pais' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='4')
                            v-select(v-model='provinciaVal' :items='provinciaLst' item-text='id' label='Provincia' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='4')
                            v-select(v-model='cantonVal' :items='cantonLst' item-text='id' label='Ciudad' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='8')
                            v-select(v-model='parroquiaVal' :items='parroquiaLst' item-text='id' label='Parroquia' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='4')
                            v-text-field.purple-input(label='Código Postal' type='number' v-model='patient.postalCode')
                          v-col(cols='12' md='12')
                            v-text-field.purple-input(v-model='patient.place' label='Lugar de Nacimiento')
                          //- v-col(cols='12' md='6')
                          //-   v-menu(ref='menu' v-model='menu' :close-on-content-click='false' :return-value.sync='date' transition='scale-transition' offset-y='' min-width='290px')
                          //-     template(v-slot:activator='{ on }')
                          //-       v-text-field(v-model='patient.bornDate' label='Fecha de Nacimiento' prepend-icon='mdi-calendar' readonly='' v-on='on')
                          //-     v-date-picker(@change="$refs.menu.save(date), calc_edad()" v-model='patient.bornDate' no-title='' scrollable='' style='margin:0px;')
                          //-       v-spacer
                          //- v-col(cols='4' md="2")
                          //-   v-text-field.purple-input(v-model='patient.years' label='Años' readonly disabled)
                          //- v-col(cols='4' md="2")
                          //-   v-text-field.purple-input(v-model='patient.months' label='Meses' readonly disabled)
                          //- v-col(cols='4' md="2")
                          //-   v-text-field.purple-input(v-model='patient.days' label='Días' readonly disabled)
            v-tab-item(value='tab-1-3')
              v-card(flat='')
                v-card-text
                  h3(style="text-align: center; color: primary;") DATOS DE RESIDENCIA
                  v-row(justify='center')
                    v-col(cols='12' md='12')
                      v-container.py-0
                        v-row
                          //- <!--v-col(cols='12' md='4')-->
                          //-   <!--v-select(v-model='patient.cityHome' :items='country[0].data' item-text='data' label='Ciudad' hide-details='' prepend-icon='mdi-map' single-line='')-->
                          //- <!--v-col(cols='12' md='4')-->
                          //-   <!--v-select(v-model='patient.countryHome' :items='country' item-text='id' label='País' hide-details='' prepend-icon='mdi-map' single-line='')-->
                          //- <!--v-col(cols='12' md='4')-->
                          //-   <!--v-text-field.purple-input(v-model='patient.parish' label='Parroquia')-->
                          v-col(cols='12' md='4')
                            v-select(v-model='paisValRes' :items='paisLstRes' item-text='id' label='Pais' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='4')
                            v-select(v-model='provinciaValRes' :items='provinciaLstRes' item-text='id' label='Provincia' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='4')
                            v-select(v-model='cantonValRes' :items='cantonLstRes' item-text='id' label='Ciudad' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='8')
                            v-select(v-model='parroquiaValRes' :items='parroquiaLstRes' item-text='id' label='Parroquia' hide-details='' prepend-icon='mdi-map' single-line='')
                          v-col(cols='12' md='4')
                            v-text-field.purple-input(label='Código Postal' type='number' v-model='patient.postalCodeRes')
                          v-col(cols='12' md='8')
                            v-text-field.purple-input(v-model='patient.street' label='Calle Principal')
                          v-col(cols='12' md='4')
                            v-text-field.purple-input(v-model='patient.numberStreet' label='Numero')
                          v-col(cols='12' md='6')
                            v-text-field.purple-input(v-model='patient.street2' label='Calle Secundaria')
                          v-col(cols='12' md='6')
                            v-text-field.purple-input(v-model='patient.neighborhood' label='Barrio')
                          v-col(cols='12' md='12')
                            v-text-field.purple-input(v-model='patient.referenceHome' label='Referencia')
            v-tab-item(value='tab-1-4')
              v-card(flat='')
                v-card-text
                  h3(style="text-align: center; color: primary;") DATOS ADICIONALES
                  v-row
                    v-col(cols='12' md='4')
                      v-select(v-model='patient.ethnicity' :items='ethnicityLst' label='Autoidentificación Étnica' hide-details='' single-line='')
                    v-col(cols='12' md='4')
                      v-select(v-model='patient.ethnicityNat' :items='ethnicityNatLst' label='Nacionalidad Étnica' hide-details='' single-line='')
                    v-col(cols='12' md='4')
                      v-select(v-model='patient.town' :items='townLst' label='Pueblo' hide-details='' single-line='')
                    v-col(cols='12' md='4')
                      v-select(v-model='patient.educationLevel' :items='educationLevelLst' label='Nivel de Educación' hide-details='' single-line='')
                    v-col(cols='12' md='4')
                      v-select(v-model='patient.stateEducationLevel' :items='stateEducationLevelLst' label='Estado de Nivel de Educación' hide-details='' single-line='')
                    v-col(cols='12' md='4')
                      v-select(v-model='patient.companyWorkType' :items='companyWorkTypeLst' label='Tipo de Empresa de Trabajo' hide-details='' single-line='')
                    v-col(cols='12' md='6')
                      v-text-field.purple-input(v-model='patient.ocupation' label='Ocupación')
                    v-col(cols='12' md='3')
                      v-select(v-model='patient.sureIess' :items='sureIessLst' label='Seguro IESS' hide-details='' single-line='')
                    v-col(cols='12' md='3')
                      v-text-field.purple-input(v-model='patient.sureSecundary' label='Seguro Secundario')
            v-tab-item(value='tab-1-5')
              v-card(flat='')
                v-card-text
                  h3(style="text-align: center; color: primary;") DATOS DE CONTACTO
                  v-row
                    v-col(cols='12' md='6')
                      v-text-field.purple-input(v-model='patient.contactName' label='En caso necesario llamar a?')
                    v-col(cols='12' md='3')
                      v-text-field.purple-input(v-model='patient.contactKinship' label='Parentezco')
                    v-col(cols='12' md='3')
                      v-text-field.purple-input(v-model='patient.contactPhone' label='Teléfono')
                    v-col(cols='12' md='6')
                      v-text-field.purple-input(v-model='patient.contactAddress' label='Dirección')
                    v-col(cols='12' md='6')
                      v-text-field.purple-input(v-model='patient.referedBy' label='Referido por')
                    v-col(cols='12' md='4')
                      v-text-field.purple-input(v-model='patient.fatherName' label='Nombre del padre')
                    v-col(cols='12' md='4')
                      v-text-field.purple-input(v-model='patient.motherName' label='Nombre de la madre')
                    v-col(cols='12' md='4')
                      v-text-field.purple-input(v-model='patient.billName' label='Factura a nombre de')
        v-tab-item
          antecedentes(:patientSelected="selectedPatient" :idPatient="idPatient")
        v-tab-item
          signos-vitales(:patientSelected="selectedPatient" :idPatient="idPatient")
        v-tab-item
          examen-fisico(:patientSelected="selectedPatient" :idPatient="idPatient")
        v-tab-item
          preguntas-frecuentes(:patientSelected="selectedPatient" :idPatient="idPatient")
        v-tab-item
          citas(:patientSelected="selectedPatient" :idPatient="idPatient")
      v-col.text-right(cols='12' v-if="selectTab")
        v-row(v-if="selectedPatient")
          v-col(cols="6" md="3" offset-md="6")
            v-btn.mr-0(color='secondary' @click='printDataPatient' style="width: 100%;" :loading="loadingPrintDataPatient")
              | IMPRIMIR DATOS
          v-col(cols="6" md="3")
            v-btn.mr-0(color='primary' @click='validateIdentifyType' style="width: 100%;" :loading="loadingSavePatient")
              | GUARDAR
        v-row(v-if="!selectedPatient")
          v-col(cols="6" md="3" offset-md="9")
            v-btn.mr-0(color='primary' @click='validateIdentifyType' style="width: 100%;" :loading="loadingSavePatient")
              | GUARDAR
</template>
<script>
  // import firebase from 'firebase'
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import 'firebase/storage'
  import 'firebase/database'
  import * as functions from '../../../../functions.js'
  import jsonPatient from '@/views/dashboard/pages/PdfFiles/patientData.json'
  import axios from 'axios'
  import {enviarEvento} from "../../../../functions.js";
  export default {
    components: {
      SignosVitales: () => import('../../pages/SignosVitales.vue'),
      Antecedentes: () => import('../../pages/Antecedentes.vue'),
      ExamenFisico: () => import('../../pages/ExamenFisico.vue'),
      PreguntasFrecuentes: () => import('../../pages/PreguntasFrecuentes.vue'),
      Citas: () => import('../../pages/Citas.vue'),
    },
    props: {
      selectedPatient: null,
      idPatient: null,
      seeData: null,
      seeAppointment: null,
    },
    data: () => ({
      emailRules: [
        v => /^$|\S+@\S+\.\S+/.test(v) || 'Email inválido',
      ],
      paisLstFilter: [],
      provinciaLstFilter: [],
      parroquiaLstFilter: [],
      cantonLstFilter: [],
      provinciaLst: [],
      cantonLst: [],
      parroquiaLst: [],
      paisLstFilterRes: [],
      provinciaLstFilterRes: [],
      parroquiaLstFilterRes: [],
      cantonLstFilterRes: [],
      provinciaLstRes: [],
      cantonLstRes: [],
      parroquiaLstRes: [],
      loadingSavePatient: false,
      loadingPrintDataPatient: false,
      tabData: 'tab-1-1',
      selectTab: true,
      menu: false,
      dialog: false,
      imageName: '',
      imageUrl: '',
      imageFile: '',
      paisVal: '',
      provinciaVal: '',
      cantonVal: '',
      parroquiaVal: '',
      paisValRes: '',
      provinciaValRes: '',
      cantonValRes: '',
      parroquiaValRes: '',
      patientBefore: {},
      patient: {
        hcNumber: '',
        pais: '',
        canton: '',
        provincia: '',
        parroquia: '',
        postalCode: '',
        paisRes: '',
        cantonRes: '',
        provinciaRes: '',
        parroquiaRes: '',
        postalCodeRes: '',
        names: '',
        lastNames: '',
        tipoId: 'Cédula',
        id: '',
        email: '',
        sex: '',
        estadoCivil: '',
        phone1: '',
        phone2: '',
        phone3: '',
        active: true,
        notas: '',
        city: '',
        country: '',
        place: '',
        nationality: '',
        bornDate: '',
        years: '0',
        months: '0',
        days: '0',
        cityHome: '',
        countryHome: '',
        parish: '',
        street: '',
        numberStreet: '',
        street2: '',
        neighborhood: '',
        referenceHome: '',
        ethnicity: '',
        ethnicityNat: '',
        town: '',
        educationLevel: '',
        stateEducationLevel: '',
        companyWorkType: '',
        ocupation: '',
        sureIess: '',
        sureSecundary: '',
        contactName: '',
        contactKinship: '',
        contactPhone: '',
        contactAddress: '',
        imagePatientUrl: '',
        idimg: '',
        addEdit: false,
        referedBy: '',
        fatherName: '',
        motherName: '',
        billName: '',
      },
      ethnicityLst: ['MESTIZO/A', 'MULATO/A', 'INDÍGENA', 'AFROECUATORIANO', 'BLANCOS', 'ASIÁTICO'],
      ethnicityNatLst: ['Achuar', 'Andoa', 'Awá', 'Chachi', 'Cofán', 'Épera', 'Huaorani', 'Quichua', 'Secoya', 'Shiwiar', 'Shuar', 'Siona', 'Tsáchila', 'Zápara'],
      townLst: ['Cañari', 'Caranqui', 'Cayambi', 'Chibuleo', 'Guaranga', 'Huancavilca', 'Kitukara', 'Manta', 'Natabuela', 'Otavalo', 'Palta', 'Panzaleo', 'Pasto', 'Puruhá', 'Quisapincha', 'Salasaca', 'Saraguro', 'Tomabela'],
      educationLevelLst: ['Primaria', 'Secundaria', 'Superior', 'Otro'],
      stateEducationLevelLst: ['Cursando', 'Finalizado', 'Otro'],
      companyWorkTypeLst: ['Privada', 'Pública', 'Otro'],
      sureIessLst: ['Aporta', 'No Aporta'],
      requeridos: [
        value => !!value || 'Requerido',
      ],
      date: null,
      items: ['Hombre', 'Mujer'],
      tipoId: ['Cédula', 'Pasaporte'],
      estadoCivilLst: ['Soltero', 'Casado', 'Viudo'],
      email: [
        value => !!value || 'Requerido',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Correo inválido'
        },
      ],
      identi: [
        value => !!value || 'Requerido',
        value => (value || '').length === 10 || 'Deben ser 10 dígitos',
        value => {
          const pattern = /^\d{10}$/
          return pattern.test(value) || 'Cédula inválida'
        },
      ],
      telefono1: [
        // value => !!value || 'Requerido',
        value => (value || '').length === 10 || 'Deben ser 10 dígitos',
        // value => {
        //   const pattern = /^\d{10}$/
        //   return pattern.test(value) || 'Teléfono inválido'
        // },
      ],
      telefono23: [
        value => {
          const pattern = /^\d{10}$/
          return pattern.test(value) || 'Teléfono inválido'
        },
      ],
      snackbar: {
        show: false,
        text: '',
        color: '',
        place: '',
      },
      userStatus: true,
    }),
    computed: {
      paisLst () {
        return this.$store.state.paises.paises
      },
      paisLstRes () {
        return this.$store.state.paises.paises
      },
      country () {
        return this.$store.state.countries.countries
      },
      patientLst () {
        return this.$store.state.patients.pacientes
      },
      patientsPlan () {
        return this.$store.state.suscriptionPlan.plan
      },
    },
    watch: {
      patientsPlan () {
        if (this.patientLst.length >= this.patientsPlan) {
          this.userStatus = false
        } else {
          this.userStatus = true
        }
      },
      paisVal () {
        this.patient.pais = this.paisVal !== undefined ? this.paisVal : ''
        this.paisLstFilter = this.paisLst.filter((item) => {
          return (item.id === this.paisVal)
        })
        if (this.paisLstFilter[0]) {
          this.provinciaLst = this.paisLstFilter[0].provincia
        }
      },
      provinciaVal () {
        this.patient.provincia = this.provinciaVal !== undefined ? this.provinciaVal : ''
        this.provinciaLstFilter = this.provinciaLst.filter(item => {
          return (item.id === this.provinciaVal)
        })
        if (this.provinciaLstFilter[0]) {
          this.cantonLst = this.provinciaLstFilter[0].cantones
        }
      },
      cantonVal () {
        this.patient.canton = this.cantonVal !== undefined ? this.cantonVal : ''
        this.cantonLstFilter = this.cantonLst.filter(item => {
          return (item.id === this.cantonVal)
        })
        if (this.cantonLstFilter[0]) {
          this.parroquiaLst = this.cantonLstFilter[0].parroquias
        }
      },
      parroquiaVal () {
        this.patient.parroquia = this.parroquiaVal !== undefined ? this.parroquiaVal : ''
        this.parroquiaLstFilter = this.parroquiaLst.filter(item => {
          return (item.id === this.parroquiaVal)
        })
        if (this.parroquiaLstFilter[0]) {
          this.patient.postalCode = this.parroquiaLstFilter[0].codigoPostal
        }
      },
      paisValRes () {
        this.patient.paisRes = this.paisValRes !== undefined ? this.paisValRes : ''
        this.paisLstFilterRes = this.paisLstRes.filter((item) => {
          return (item.id === this.paisValRes)
        })
        if (this.paisLstFilterRes[0]) {
          this.provinciaLstRes = this.paisLstFilterRes[0].provincia
        }
      },
      provinciaValRes () {
        this.patient.provinciaRes = this.provinciaValRes !== undefined ? this.provinciaValRes : ''
        this.provinciaLstFilterRes = this.provinciaLstRes.filter(item => {
          return (item.id === this.provinciaValRes)
        })
        if (this.provinciaLstFilterRes[0]) {
          this.cantonLstRes = this.provinciaLstFilterRes[0].cantones
        }
      },
      cantonValRes () {
        this.patient.cantonRes = this.cantonValRes !== undefined ? this.cantonValRes : ''
        this.cantonLstFilterRes = this.cantonLstRes.filter(item => {
          return (item.id === this.cantonValRes)
        })
        if (this.cantonLstFilterRes[0]) {
          this.parroquiaLstRes = this.cantonLstFilterRes[0].parroquias
        }
      },
      parroquiaValRes () {
        this.patient.parroquiaRes = this.parroquiaValRes !== undefined ? this.parroquiaValRes : ''
        this.parroquiaLstFilterRes = this.parroquiaLstRes.filter(item => {
          return (item.id === this.parroquiaValRes)
        })
        if (this.parroquiaLstFilterRes[0]) {
          this.patient.postalCodeRes = this.parroquiaLstFilterRes[0].codigoPostal
        }
      },
    },
    mounted () {
      enviarEvento('patient_profile', { categoria: 'interaccion', etiqueta: 'inicio' })
      if (this.selectedPatient) {
        this.patientBefore = this.selectedPatient
        this.patient = this.selectedPatient
        // this.paisVal = this.patient.pais
        // if (!this.paisVal || this.paisVal === '') {
        //   this.paisVal = this.$store.state.paises.paises[0]
        // }
        this.provinciaVal = this.patient.provincia
        this.cantonVal = this.patient.canton
        this.parroquiaVal = this.patient.parroquia
        this.paisValRes = this.patient.paisRes
        // if (!this.paisValRes || this.paisValRes === '') {
        //   this.paisValRes = this.$store.state.paises.paises[0]
        // }
        this.provinciaValRes = this.patient.provinciaRes
        this.cantonValRes = this.patient.cantonRes
        this.parroquiaValRes = this.patient.parroquiaRes
      } else {
        // if (!this.paisVal || this.paisVal === '') {
        //   this.paisVal = this.$store.state.paises.paises[0]
        // }
        // if (!this.paisValRes || this.paisValRes === '') {
        //   this.paisValRes = this.$store.state.paises.paises[0]
        // }
      }
      if (this.$store.state.patients.pacientes.length >= this.$store.state.suscriptionPlan.plan) {
        this.userStatus = false
      } else {
        this.userStatus = true
      }
    },
    created () {
      this.patient = {
        hcNumber: '',
        names: '',
        lastNames: '',
        tipoId: 'Cédula',
        id: '',
        email: '',
        sex: '',
        estadoCivil: '',
        phone1: '',
        phone2: '',
        phone3: '',
        active: true,
        notas: '',
        city: '',
        country: '',
        place: '',
        nationality: '',
        bornDate: '',
        years: '0',
        months: '0',
        days: '0',
        cityHome: '',
        countryHome: '',
        parish: '',
        street: '',
        numberStreet: '',
        street2: '',
        neighborhood: '',
        referenceHome: '',
        ethnicity: '',
        ethnicityNat: '',
        town: '',
        educationLevel: '',
        stateEducationLevel: '',
        companyWorkType: '',
        ocupation: '',
        sureIess: '',
        sureSecundary: '',
        contactName: '',
        contactKinship: '',
        contactPhone: '',
        contactAddress: '',
        imagePatientUrl: 'data:image/jpeg;base64,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',
        idimg: '',
        addEdit: false,
        referedBy: '',
        fatherName: '',
        motherName: '',
        billName: '',
      }
    },
    methods: {
      exitPatientDialog () {
        this.selectedPatient = this.patientBefore
        this.$emit('exitPatient')
      },
      pickFile () {
        this.$refs.image.click()
      },
      calc_edad () {
        var resp = functions.getAge(this.patient.bornDate)
        this.patient.years = resp[0]
        this.patient.months = resp[1]
        this.patient.days = resp[2]
      },
      onFilePicked (e) {
        const files = e.target.files
        if (files[0] !== undefined) {
          this.imageName = files[0].name
          if (this.imageName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.imageUrl = fr.result
            this.imageFile = files[0]
          })
        } else {
          this.imageName = ''
          this.imageFile = ''
          this.imageUrl = ''
        }
      },
      exit () {
        this.$emit('exitPatient')
      },
      savePatient () {
        this.patient.completeData = this.patient.names + ' ' + this.patient.lastNames + ' | ' + this.patient.id
        if (this.patient.addEdit) {
          if (this.$refs.formPatient.validate()) {
            if (this.patient.id !== '') {
              const patient = this.patientLst.filter(patient => {
                return (patient.data.data.id === this.patient.id)
              })
              if (patient.length > 0) {
                if (patient[0].id !== this.patient.uid) {
                  this.loadingSavePatient = false
                  this.snackbar = {
                    show: true,
                    color: 'red',
                    text: 'La identificación del paciente ya está registrada',
                  }
                  return
                }
              }
            }
            if (this.patient.phone2.length === 10 || this.patient.phone2.length === 0) {
              this.$store.dispatch('patients/updatePatient', [this.patient, this.idPatient]).then(resolve => {
                this.loadingSavePatient = false
                this.snackbar = {
                  show: true,
                  color: 'green',
                  text: 'Paciente editado correctamente',
                }
                this.clearPatient()
                setTimeout(() => {
                  this.$emit('finishCreate')
                }, 2000)
              }, reject => {
                this.loadingSavePatient = false
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Error al guardar el paciente',
                }
              })
            } else {
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'El número de celular debe tener 10 dígitos',
              }
              this.loadingSavePatient = false
            }
          } else {
            this.loadingSavePatient = false
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Por favor ingrese todos los datos requeridos',
            }
          }
          return
        }
        if (this.patientLst) {
          if (this.patientLst.length > 0) {
            if (this.patient.id !== '') {
              const patient = this.patientLst.filter(patient => {
                return (patient.data.data.id === this.patient.id)
              })
              if (patient.length > 0) {
                this.loadingSavePatient = false
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'La identificación del paciente ya está registrada',
                }
                return
              }
            }
          }
        }
        if (this.$refs.formPatient.validate()) {
          if (this.patient.phone2.length === 10 || this.patient.phone2.length === 0) {
            this.$store.dispatch('patients/addPatient', this.patient).then(resolve => {
              this.snackbar = {
                show: true,
                color: 'green',
                text: 'Paciente guardado correctamente',
              }
              this.loadingSavePatient = false
              this.clearPatient()
              setTimeout(() => {
                this.$emit('finishCreate')
              }, 2000)
            }, reject => {
              this.loadingSavePatient = false
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Error al guardar el paciente',
              }
            })
          } else {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'El número de celular debe tener 10 dígitos',
            }
            this.loadingSavePatient = false
          }
        } else {
          this.loadingSavePatient = false
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Por favor ingrese todos los datos requeridos',
          }
        }
      },
      validateIdentifyType () {
        this.loadingSavePatient = true
        if (this.patient.id === '') {
          this.savePatient()
        } else {
          if (this.patient.tipoId === 'Pasaporte') {
            this.savePatient()
          } else {
            this.correct = functions.validIdentNumber(this.patient.id)
            if (this.correct === 1) {
              this.savePatient()
            } else {
              this.loadingSavePatient = false
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Verificar número de cédula',
              }
            }
          }
        }
      },
      clearPatient () {
        this.patientBefore = {}
        this.patient = {
          hcNumber: '',
          names: '',
          lastNames: '',
          tipoId: 'Cédula',
          id: '',
          email: '',
          sex: '',
          estadoCivil: '',
          phone1: '',
          phone2: '',
          phone3: '',
          active: true,
          notas: '',
          city: '',
          country: '',
          place: '',
          nationality: '',
          bornDate: '',
          years: '0',
          months: '0',
          days: '0',
          cityHome: '',
          countryHome: '',
          parish: '',
          street: '',
          numberStreet: '',
          street2: '',
          neighborhood: '',
          referenceHome: '',
          ethnicity: '',
          ethnicityNat: '',
          town: '',
          educationLevel: '',
          stateEducationLevel: '',
          companyWorkType: '',
          ocupation: '',
          sureIess: '',
          sureSecundary: '',
          contactName: '',
          contactKinship: '',
          contactPhone: '',
          contactAddress: '',
          imagePatientUrl: 'data:image/jpeg;base64,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',
          idimg: '',
          addEdit: false,
          referedBy: '',
          fatherName: '',
          motherName: '',
          billName: '',
        }
      },
      upload () {
        const storageRef = firebase.storage().ref()
        const currentUser = firebase.auth().currentUser
        const code = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        if (this.patient.idimg === '') {
          this.patient.idimg = code
        }
        const mountainsRef = storageRef.child(`images/patient/profile/${this.patient.idimg}`)
        mountainsRef.put(this.imageFile).then(snapshot => {
          snapshot.ref.getDownloadURL().then(downloadURL => {
            this.imageUrl = downloadURL
            this.patient.imagePatientUrl = this.imageUrl
            firebase.database().ref(`users/${currentUser.uid}/urlImg`).set(
              this.imageUrl,
            ).then(() => {
              this.$store.dispatch('setLocalStorageData', { item: 'user', obj: this.user })
            })
            this.dialog = false
          })
        })
      },
      async printDataPatient () {
        this.loadingPrintDataPatient = true
        // this.patient.imagePatientUrl = 'data:image/jpeg;base64,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'
        var pdfMake = require('pdfmake/build/pdfmake.js')
        if (pdfMake.vfs === undefined) {
          var pdfFonts = require('pdfmake/build/vfs_fonts.js')
          pdfMake.vfs = pdfFonts.pdfMake.vfs
        }
        // const { createCanvas, loadImage } = require('canvas')
        // function getImage (url, size) {
        //   return loadImage(url, { useCORS: true }).then(image => {
        //     const canvas = createCanvas(size, size)
        //     const ctx = canvas.getContext('2d')
        //     ctx.drawImage(image, 0, 0)
        //     return canvas.toDataURL()
        //   })
        // }
        // const imageData = await getImage(this.patient.imagePatientUrl, 150)
        var base64Img = ''
        try {
          base64Img = await axios
            .get(this.patient.imagePatientUrl, {
              responseType: 'arraybuffer',
            })
            .then(response =>
              Buffer.from(response.data, 'binary').toString('base64'),
            )
        } catch {
          base64Img = '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'
        }
        var docDefinition = JSON.stringify(jsonPatient)
        const imgData = 'data:image/jpeg;base64,' + base64Img
        docDefinition = docDefinition.replace('img_patient', imgData)
        docDefinition = docDefinition.replace('name_patient', this.patient.names)
        docDefinition = docDefinition.replace('last_name_patient', this.patient.lastNames)
        docDefinition = docDefinition.replace('tipoId', this.patient.tipoId)
        docDefinition = docDefinition.replace('id_patient', this.patient.id)
        docDefinition = docDefinition.replace('mail_patient', this.patient.email)
        docDefinition = docDefinition.replace('sexo_paciente', this.patient.sex)
        docDefinition = docDefinition.replace('estado_civil_paciente', this.patient.estadoCivil)
        docDefinition = docDefinition.replace('celular_paciente', this.patient.phone2)
        docDefinition = docDefinition.replace('tlf_principal', this.patient.phone1)
        docDefinition = docDefinition.replace('tlf_secundario', this.patient.phone3)
        docDefinition = docDefinition.replace('paciente_activo', this.patient.active ? 'SI' : 'NO')
        docDefinition = docDefinition.replace('nacionalidad_nac_paciente', this.patient.nationality)
        docDefinition = docDefinition.replace('ciudad_nac_paciente', this.patient.city)
        docDefinition = docDefinition.replace('pais_nac_paciente', this.patient.country)
        docDefinition = docDefinition.replace('lugar_nac_paciente', this.patient.place)
        docDefinition = docDefinition.replace('fec_nac_paciente', this.patient.bornDate)
        docDefinition = docDefinition.replace('years_nac_paciente', this.patient.years)
        docDefinition = docDefinition.replace('months_nac_paciente', this.patient.months)
        docDefinition = docDefinition.replace('days_nac_paciente', this.patient.days)
        docDefinition = docDefinition.replace('ciudad_res_paciente', this.patient.cityHome)
        docDefinition = docDefinition.replace('pais_res_paciente', this.patient.countryHome)
        docDefinition = docDefinition.replace('parroquia_res_paciente', this.patient.parish)
        docDefinition = docDefinition.replace('main_street_patient', this.patient.street)
        docDefinition = docDefinition.replace('number_street_patient', this.patient.numberStreet)
        docDefinition = docDefinition.replace('secondary_street_patient', this.patient.street2)
        docDefinition = docDefinition.replace('barrio_res_patient', this.patient.neighborhood)
        docDefinition = docDefinition.replace('autoidentificacion_adi_paciente', this.patient.ethnicity)
        docDefinition = docDefinition.replace('nac_et_adi_paciente', this.patient.ethnicityNat)
        docDefinition = docDefinition.replace('pueblo_adi_paciente', this.patient.town)
        docDefinition = docDefinition.replace('level_edu_adi_paciente', this.patient.educationLevel)
        docDefinition = docDefinition.replace('state_level_adi_paciente', this.patient.stateEducationLevel)
        docDefinition = docDefinition.replace('company_adi_paciente', this.patient.companyWorkType)
        docDefinition = docDefinition.replace('ocupacion_adi_paciente', this.patient.ocupation)
        docDefinition = docDefinition.replace('seguro_iess_adi_paciente', this.patient.sureIess)
        docDefinition = docDefinition.replace('seguro_privado_adi_paciente', this.patient.sureSecundary)
        docDefinition = docDefinition.replace('name_con_paciente', this.patient.contactName)
        docDefinition = docDefinition.replace('parentezco_con_paciente', this.patient.contactKinship)
        docDefinition = docDefinition.replace('dir_con_paciente', this.patient.contactAddress)
        docDefinition = docDefinition.replace('tlf_con_paciente', this.patient.contactPhone)
        docDefinition = docDefinition.replace('nombre_padre', this.patient.fatherName ? this.patient.fatherName : '')
        docDefinition = docDefinition.replace('nombre_madre', this.patient.motherName ? this.patient.motherName : '')
        docDefinition = docDefinition.replace('factura_a_nombre', this.patient.billName ? this.patient.billName : '')
        docDefinition = JSON.parse(docDefinition)
        this.loadingPrintDataPatient = false
        pdfMake.createPdf(docDefinition).download('Datos_de_Paciente.pdf')
      },
    },
  }
</script>
<style>
  .v-tabs--vertical > .v-tabs-bar .v-tabs-bar__content {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 50px;
  }
  .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
    border: none;
    border-radius: 5px;
    color: #fff;
    background: linear-gradient(0deg, rgba(0,172,238,1) 0%, rgba(2,126,251,1) 100%);
    box-shadow: inset 2px 2px 2px 0px rgba(255,255,255,.5);
    perspective: 230px;
    box-shadow: inset 2px 2px 2px 0px rgb(255 255 255 / 50%), 7px 7px 20px 0px rgb(0 0 0 / 10%), 4px 4px 5px 0px rgb(0 0 0 / 10%);
    outline: none;
  }
</style>
